var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"editor2",attrs:{"id":"editor2","className":"editor2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }